import React, { Component, createRef } from 'react'
import firebase from 'firebase/app'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import { connect } from 'react-redux'
import {
  Grid,
  MenuItem,
  withStyles,
  Typography,
} from '@material-ui/core'

import {
  addMarket,
  getMarket,
  editMarket,
  getMarketByUserId,
  triggerResetPassword,
} from '../actions/market'
import { ROUTES, IS_SHOP, IS_ADMIN } from '../constant'
import { validateEmail, validatePhone } from '../helpers'
import Line from '../components/Line'
import Select from '../components/Select'
import Button from '../components/Button'
import Inline from '../components/Inline'
import InputText from '../components/InputText'
import Breadcrumb from '../components/Breadcrumb'


const styles = theme => ({
  root: {
    padding: theme.spacing(1),
  },
  formLine: {
    marginTop: theme.spacing(1),
  },
  contact: {
    width: '100%',
    maxWidth: 900,
    margin: '0 auto',
    padding: theme.spacing(2),
    paddingTop: 0,
    marginTop: theme.spacing(2),
    border: '1px solid #d9dee3',
  },
  reinit: {
    margin: '0 auto',
    marginTop: theme.spacing(1),
  },
  warningTypo: {
    marginTop: theme.spacing(2),
  },
  submit: {
    marginTop: theme.spacing(3),
  },
})


class AddMarket extends Component {
  /* LIFECYCLE */

  /**
   * @constructor
   * @param {*} props - Properties of Component
   */
  constructor(props) {
    super(props)

    this.state = {
      isEdition: false,
      errorEmail: false,
      errorPhone: false,
      errorContactPhone: false,
      errorContactEmail: false,
      ...this.getDefaultFormValues(),
    }

    this.firstInput = createRef()
  }

  /**
   * @componentDidMount
   */
  componentDidMount() {
    const { location, item } = this.props
    const { uid } = queryString.parse(location.search)
    this.focusFirstInput()

    if (IS_SHOP) {
      this.props.getMarketByUserId()
    } else {
      if (uid && item.id !== uid) {
        this.props.getMarket(uid)
      } else if (uid && item.id === uid) {
        this.synchronizeItem(item)
      }
    }
  }

  /**
   * @componentWillReceiveProps
   * @param {*} nextProps - Next properties of the Component
   */
  componentWillReceiveProps(nextProps) {
    const { location, item } = nextProps

    if (IS_ADMIN && ((location !== this.props.location) || (item !== this.props.item))) {
      const { uid } = queryString.parse(location.search)

      if (uid && item.id !== uid) {
        this.props.getMarket(uid)
      } else {
        this.synchronizeItem(item)
      }
    } else if (IS_SHOP && (item !== this.props.item)) {
      this.synchronizeItem(item)
    }
  }


  /* METHODS */

  getDefaultFormValues = () => ({
    lat: '',
    lng: '',
    web: '',
    name: '',
    email: '',
    phone: '',
    address: '',
    category: '',
    schedule: '',
    keywords: '',
    icon_type: '',
    description: '',
    contact_phone: '',
    contact_email: '',
    notification_emails: '',
  })

  synchronizeItem = item => {
    this.setState({
      isEdition: true,
      web: item.web,
      name: item.name,
      email: item.email,
      phone: item.phone,
      address: item.address,
      category: item.category,
      schedule: item.schedule,
      icon_type: item.icon_type,
      description: item.description,
      contact_name: item.contact_name,
      contact_phone: item.contact_phone,
      contact_email: item.contact_email,
      keywords: (item.keywords || []).join(','),
      notification_emails: item.notification_emails,
      lat: item.coordinates ? item.coordinates.latitude : '',
      lng: item.coordinates ? item.coordinates.longitude : '',
    })
  }

  getFormValues = () => {
    const values = Object.keys(this.getDefaultFormValues()).reduce((acc, key) => {
      acc[key] = this.state[key]

      return acc
    }, {})

    if (values.lat && values.lng) {
      values.coordinates = new firebase.firestore.GeoPoint(parseFloat(values.lat), parseFloat(values.lng))
    }

    delete values.lat
    delete values.lng

    values.keywords = (values.keywords || '').split(',')

    return values
  }

  handleChange = e => this.setState({ [e.target.name]: e.target.value })

  handleEmailChange = e => this.setState({
    errorEmail: false,
    ...this.handleChange(e),
  })

  handlePhoneChange = e => this.setState({
    errorPhone: false,
    ...this.handleChange(e),
  })


  handleNotificationEmailsChange = e => this.setState({
    errorContactEmail: false,
    ...this.handleChange(e),
  })

  focusFirstInput = () => {
    const { current: input } = this.firstInput

    if (input) {
      input.focus()
    }
  }

  getNotificationEmails = (notification_emails) => {
    const emails = []
    const result = /([a-zA-Z\-0-9.]+@[a-zA-Z\-0-9.]+[,]*)+/.exec(notification_emails || '') || []

    for (let i = 0; i < result.length; i++) {
      const email = result[i].replace(',', '')

      if (!emails.includes(email)) {
        emails.push(email)
      }
    }

    return emails
  }

  isSubmitable = () => {
    if (this.props.isLoading) {
      return false
    }

    const {
      notification_emails,
      ...data
    } = this.getDefaultFormValues()

    /*
    if (notification_emails && !this.getNotificationEmails(notification_emails).length) {
      return false
    }
    */

    if (!parseInt(this.state.lat, 10) || !parseInt(this.state.lng, 10)) {
      return false
    }

    return Object.keys(data)
      .filter(key => !['web', 'description', 'keywords', 'phone', 'contact_phone'].includes(key))
      .every(key => !!this.state[key])
  }

  handleTriggerResetPassword = () => {
    const { item } = this.props
    const { contact_email } = this.state

    if (item.id && contact_email) {
      this.props.triggerResetPassword(item.contact_email)
    }
  }

  handleValidateEmail = stateKey => (e) => {
    const { value } = e.target

    this.setState({ [stateKey]: validateEmail(value) })
  }

  handleValidatePhone = (stateKey) => (e) => {
    const { value } = e.target
    const nextValue = validatePhone(value)

    if (!nextValue && !!value) {
      return this.setState({
        [stateKey]: true,
      })
    }

    this.handleChange({
      target: {
        name: e.target.name,
        value: value ? nextValue : '',
      },
    })
    return this.setState({
      [stateKey]: false,
    })
  }

  handleSubmit = async () => {
    const { isEdition } = this.state
    const { item } = this.props

    if (isEdition) {
      await this.props.editMarket(item.id, this.getFormValues())
      return this.props.history.push(`${ROUTES.MARKET}/${item.id}`)
    }

    const validated = await this.props.addMarket(this.getFormValues())

    if (validated) {
      this.setState(this.getDefaultFormValues())
    }

    return this.focusFirstInput()
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      classes,
      isLoading,
    } = this.props
    const {
      isEdition,
      web,
      lat,
      lng,
      name,
      email,
      phone,
      address,
      schedule,
      category,
      keywords,
      icon_type,
      errorEmail,
      errorPhone,
      description,
      contact_phone,
      contact_email,
      errorContactPhone,
      errorContactEmail,
      notification_emails,
    } = this.state

    return (
      <div className={classes.root}>
        {IS_SHOP && (
          <Breadcrumb
            data={[
              { label: 'Accueil', to: '/' },
              'Modification du profil',
            ]}
          />
        )}

        <Line>{isEdition || IS_SHOP ? 'Modifier le commerce' : 'Ajouter un commerce'}</Line>

        <form noValidate>
          <InputText
            fullWidth
            label="Nom*"
            name="name"
            value={name}
            ref={this.firstInput}
            className={classes.formLine}
            onChange={this.handleChange}
          />

          <Inline className={classes.formLine}>
            <InputText
              fullWidth
              tag="div"
              name="phone"
              value={phone}
              label="Téléphone"
              onChange={this.handlePhoneChange}
              onBlur={this.handleValidatePhone('errorPhone')}
              errorText={errorPhone && 'Le numéro de téléphone est invalide'}
            />

            <InputText
              fullWidth
              name="web"
              value={web}
              label="Site web"
              onChange={this.handleChange}
            />
          </Inline>

          <InputText
            fullWidth
            label="Adresse*"
            name="address"
            value={address}
            className={classes.formLine}
            onChange={this.handleChange}
          />

          <InputText
            fullWidth
            type="email"
            name="email"
            label="E-mail*"
            value={email}
            className={classes.formLine}
            onChange={this.handleEmailChange}
            onBlur={this.handleValidateEmail('errorEmail')}
            errorText={errorEmail && 'L\'adresse E-mail est invalide'}
          />

          <InputText
            fullWidth
            multiline
            rows={3}
            name="schedule"
            label="Horaires*"
            value={schedule}
            className={classes.formLine}
            onChange={this.handleChange}
          />

          <InputText
            fullWidth
            name="category"
            label="Catégorie*"
            value={category}
            className={classes.formLine}
            onChange={this.handleChange}
          />

          <Select
            fullWidth
            name="icon_type"
            label="Type d'icône*"
            value={icon_type}
            className={classes.formLine}
            onChange={this.handleChange}
          >
            <MenuItem value="banque">Banque</MenuItem>
            <MenuItem value="bien-etre">Bien-être</MenuItem>
            <MenuItem value="decoration">Décoration</MenuItem>
            <MenuItem value="garages">Garages</MenuItem>
            <MenuItem value="grandes-surfaces">Grandes surfaces</MenuItem>
            <MenuItem value="habillement">Habillement</MenuItem>
            <MenuItem value="hebergement">Hébergement</MenuItem>
            <MenuItem value="loisirs">Loisirs</MenuItem>
            <MenuItem value="restauration">Restauration</MenuItem>
            <MenuItem value="sante">Santé</MenuItem>
          </Select>

          <InputText
            fullWidth
            multiline
            rows={3}
            name="description"
            label="Description"
            value={description}
            className={classes.formLine}
            onChange={this.handleChange}
          />

          <Inline className={classes.formLine}>
            <InputText
              fullWidth
              name="lat"
              value={lat}
              label="Coordonnée: Latitude*"
              onChange={this.handleChange}
            />

            <InputText
              fullWidth
              name="lng"
              value={lng}
              label="Coordonnée: Longitude*"
              onChange={this.handleChange}
            />
          </Inline>

          <InputText
            fullWidth
            name="keywords"
            value={keywords}
            className={classes.formLine}
            onChange={this.handleChange}
            label="Mots-clés (séparés par des virgules)"
          />

          {IS_ADMIN && (
            <Grid
              container
              justify="center"
              direction="column"
              alignItems="center"
              className={classes.contact}
            >
              <Line>Administration commerce</Line>

              <InputText
                fullWidth
                label="Téléphone"
                name="contact_phone"
                value={contact_phone}
                className={classes.formLine}
                onChange={this.handlePhoneChange}
                onBlur={this.handleValidatePhone('errorContactPhone')}
                errorText={errorContactPhone && 'Le numéro de téléphone est invalide'}
              />

              <InputText
                fullWidth
                type="email"
                label="E-mail*"
                name="contact_email"
                value={contact_email}
                className={classes.formLine}
                onChange={this.handleNotificationEmailsChange}
                onBlur={this.handleValidateEmail('errorContactEmail')}
                errorText={errorContactEmail && 'L\'adresse E-mail est invalide'}
              />

              <Button
                color="primary"
                variant="contained"
                disabled={!isEdition}
                isLoading={isLoading}
                className={classes.reinit}
                onClick={this.handleTriggerResetPassword}
              >
                Envoyer un email de réinitialisation de mot de passe
              </Button>


              <Typography align="center" color="primary" variant="h6" className={classes.warningTypo}>Email d'alerte</Typography>
              <Typography align="center" variant="caption">Ces emails recevront une confirmation pour chaque paiement émis. Séparez chaque email par une virgule.</Typography>

              <InputText
                fullWidth
                label="Email"
                name="notification_emails"
                value={notification_emails}
                className={classes.formLine}
                onChange={this.handleChange}
              />
            </Grid>
          )}

          <Button
            fullWidth
            color="primary"
            variant="contained"
            isLoading={isLoading}
            className={classes.submit}
            onClick={this.handleSubmit}
            disabled={!this.isSubmitable()}
          >
            {isEdition || IS_SHOP ? 'Modifier' : 'Créer'}
          </Button>
        </form>
      </div>
    )
  }
}


AddMarket.propTypes = {
  item: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  addMarket: PropTypes.func.isRequired,
  getMarket: PropTypes.func.isRequired,
  editMarket: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  getMarketByUserId: PropTypes.func.isRequired,
  triggerResetPassword: PropTypes.func.isRequired,
}


const mapStateToProps = state => ({
  item: state.item,
  isLoading: state.app.isLoading,
})


export default connect(mapStateToProps, {
  addMarket,
  getMarket,
  editMarket,
  getMarketByUserId,
  triggerResetPassword,
})(withStyles(styles)(AddMarket))
